export const MIN_NOTIFICATION_INTERVAL = 1
export const MIN_MYWAVE_FREQUENCY = 1
export const MAX_MYWAVE_FREQUENCY = 10
export const DEFAULT_NOTIFICATION_INTERVAL = 1
export const DEFAULT_MYWAVE_FREQUENCY = 1
export const DEFAULT_HAS_STARTED = false
export const DEFAULT_SEND_NOTIFICATION_TIME_IN_MINUTES = 5
